import Navbar from './components/Navbar';
import Hero from './components/Hero';
import About from './components/About';
import BrandDirection from './components/BrandDirection';
import OperationGuide from './components/OperationGuide';
import Pricing from './components/Pricing';
import Terms from './components/Terms';
import Notice from './components/Notice';
import Contact from './components/Contact';
import Footer from './components/Footer';

export default function Home() {
  return (
    <div className="min-h-screen">
      <Navbar />
      <Hero />
      <About />
      <BrandDirection />
      <OperationGuide />
      <Pricing />
      <Terms />
      <Notice />
      <Contact />
      <Footer />
    </div>
  );
}
